import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTranslation } from 'react-i18next';
import dayjs from '@utils/dayjs';

// `locale` pins the calendar's own locale for callers that must not follow the UI language: the Budget
// module formats every date and number as German whatever the interface is set to (CALL-759/815), so its
// pickers pass locale="de" instead of taking i18n.language below.
function CustomDatePicker({ date, onChange, ...parentProps }) {
    // Both are consumed HERE and must not reach the DatePicker — taken off the rest object rather than
    // named in the signature, which would make them required props of an untyped .js component.
    const { allowEmpty = false, locale, ...props } = parentProps;
    const { i18n } = useTranslation();

    const handleChange = (newValue) => {
        if (allowEmpty && !newValue) {
            onChange(null);
            return;
        }

        if (!newValue || !newValue.isValid()) {
            return;
        }

        onChange(newValue);
    };

    return (
        <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale={locale ?? i18n.language}
            dateLibInstance={dayjs}
        >
            <DatePicker
                {...props}
                fullWidth={true}
                value={date}
                onChange={(newValue) => {
                    handleChange(newValue);
                }}
                slotProps={{
                    ...props.slotProps,
                    textField: {
                        ...props.slotProps?.textField,
                        variant: 'outlined',
                    },
                }}
            />
        </LocalizationProvider>
    );
}

export default CustomDatePicker;
